// @flow
import type {
  ProgressData,
} from '../types';

const setTarget = (target: string[], answered?: string[],
  skipped?: string[]) => (
  {
    target: [...target],
    answered: answered || [],
    skipped: skipped || [],
  }
);

const addAnswer = (
  progressData: ProgressData,
  answer: string,
) => {
  const {
    target,
    answered,
    skipped,
  } = progressData;
  if (target.includes(answer)) {
    if (!answered.includes(answer)) {
      answered.push(answer);
    }
    const skippedIndex = skipped.indexOf(answer);
    if (skippedIndex >= 0) {
      skipped.splice(skippedIndex, 1);
    }
  }
  return {
    target,
    answered,
    skipped,
  };
};

const skipQuestion = (
  progressData: ProgressData,
  question: string,
) => {
  const {
    target,
    answered,
    skipped,
  } = progressData;
  if (
    target.includes(question)
    && !answered.includes(question)
    && !skipped.includes(question)
  ) {
    skipped.push(question);
  }
  return {
    target,
    answered,
    skipped,
  };
};

export {
  setTarget,
  addAnswer,
  skipQuestion,
};
